import { Formik, FormikHelpers, FormikProps } from "formik";
import React, { FC, memo, useCallback } from "react";

import { FormikForm } from "@/formikComponents";
import { IPhoneFormValues, PhoneForm, validationPhoneSchema as validationSchema } from "@/views/components/Forms";
import {
  IProfileFormikProps,
  profilePartialUpdaterBuilder,
} from "@/views/ConsultantProfiles/Detail/profilePartialUpdaterBuilder";

import { Buttons } from "./Buttons";

const Form: FC<IProfileFormikProps<IPhoneFormValues>> = memo(
  ({ initialValues, validationSchema: vs, onSubmit, onCancel, source }) => {
    const handleSubmit = useCallback(
      (values: IPhoneFormValues, actions: FormikHelpers<IPhoneFormValues>) => {
        onSubmit(values, actions);
      },
      [onSubmit],
    );

    return (
      <Formik initialValues={initialValues} validationSchema={vs} onSubmit={handleSubmit}>
        {(form: FormikProps<IPhoneFormValues>) => (
          <>
            <FormikForm>
              <PhoneForm form={form} location={source.location} />
              <Buttons form={form} onClose={onCancel} />
            </FormikForm>
          </>
        )}
      </Formik>
    );
  },
);

export const PhoneFormik = profilePartialUpdaterBuilder(Form, {
  validationSchema,
  messengerContext: "",
});
